<template>
    <div class="solutions">
        <div class="title">
            <div class="title-text"><span>解决</span>方案</div>
            <div class="title-more"><span>SOLUTIONS</span></div>
        </div>
        <div class="content">
            <div class="content-left">
                <div class="content-left-item" v-for="(item, index) in list" :key="index" @click="goSolution(item)"
                    :class="{ 'content-left-items': index == activeIndex }" @mouseenter="active(index)"
                    @mouseleave="startTime">
                    <div class="line"></div>

                    <div class="num">{{ '0' + (index + 1) }}</div>
                    <div class="content-left-item-content">

                        <div class="content-left-item-content-title">{{ item.title }} <img
                                src="@/assets/images/index/left-icon.png" alt=""></div>
                        <div class="content-left-item-content-text">
                            {{ item.content }}
                        </div>
                    </div>
                </div>

            </div>
            <div class="content-right">
                <img v-lazy="ch" alt="" v-if="activeIndex == '0'"
                    @click="router.push({ path: '/solution', query: { 'data': '冲焊' } })">
                <img v-lazy="sb" alt="" v-if="activeIndex == '1'"
                    @click="router.push({ path: '/solution', query: { 'data': '设备' } })">
                <img v-lazy="ai" alt="" v-if="activeIndex == '3'"
                    @click="router.push({ path: '/solution', query: { 'data': 'AI' } })">
                <img v-lazy="ks" alt="" v-if="activeIndex == '2'"
                    @click="router.push({ path: '/solution', query: { 'data': '工厂' } })">
            </div>
        </div>
    </div>
</template>

<script setup>
import ch from '@/assets/images/index/solutions-ch.png'
import sb from '@/assets/images/index/solutions-sb.png'
import ai from '@/assets/images/index/solutions-ai.png'
import ks from '@/assets/images/index/solutions-ks.png'
import { ref, onMounted, onUnmounted } from 'vue'
let time = ref(null)
onMounted(() => {
    startTime()
})
const startTime = () => {
    if (time.value) {
        clearInterval(time.value)
    }
    time.value = setInterval(() => {
        if (activeIndex.value == 3) {
            activeIndex.value = 0
            return
        }
        activeIndex.value = activeIndex.value + 1
    }, 5000)
}
onUnmounted(() => {
    clearInterval(time.value)
})
import { useRouter } from 'vue-router'
const router = useRouter()
const goSolution = (item) => {
    router.push({
        path: '/solution',
        query: {
            'data': item.data
        }
    })
}
const activeIndex = ref(0)
const active = (index) => {

    clearInterval(time.value)
    activeIndex.value = index


}
const list = ref([
    {
        path: '/solution',
        data: '冲焊',
        title: '冲焊行业数字可视化解决方案',
        content: '冲焊行业数字化可视化解决方案依托设备数字看板、AI模型和智慧节能产品，帮助冲焊企业实现生产全过程的智能化升级。通过实时数据采集和智能分析，提高生产效率，降低能耗和成本，实现高效...'
    },
    {
        path: '/solution',
        data: '设备',
        title: '设备资产管理智能化解决方案',
        content: '设备资产管理智能化解决方案依托全球设备数字资产管理平台，实现设备全生命周期管理，优化设备性能和使用寿命。实时监控与数据分析，可帮助企业预防设备故障，提升设备利用率和生产稳定性。'
    },
    {
        path: '/solution',
        data: '矿山',
        title: '智慧矿山数字化解决方案',
        content: '智慧矿山解决方案利用全球设备数字资产管理平台和设备数字孪生平台，实现设备智能监测、生产可视化、运维智能化，提升生产效率、降低运维成本，保障矿山安全高效运行。'
    },
    {
        path: '/solution',
        data: 'AI',
        title: '智慧AI生产解决方案',
        content: '智慧AI生产解决方案利用AI模型服务平台，为企业提供智能生产优化。通过精准的数据分析和预测，企业可以优化生产流程，提高产品质量，实现智能化生产目标。'
    },

])
</script>

<style lang="less" scoped>
.solutions {
    width: 100%;
    margin-top: 6.25rem;
    padding-left: 15.3125rem;
    padding-right: 15.3125rem;
    margin-bottom: 6.25rem;
}

.title {
    font-size: 3.125rem;
    font-weight: bold;
    position: relative;
    height: 8.75rem;



    .title-text {
        position: absolute;
        top: .5625rem;
        left: .25rem;

        span {
            color: @xtxColor;
        }
    }

    .title-more {
        font-size: 6.25rem;
        -webkit-text-stroke: 2px #3E3A39;
        opacity: 0.1;
        color: transparent; //字体颜色设置为透明
        position: absolute;
        top: 0;
        left: 0;
        text-align: left;
    }
}

.content {
    width: 100%;
    height: 41.375rem;

    display: flex;
    justify-content: space-between;

    .content-left {
        width: 39.375rem;
        height: 100%;

        .content-left-items {
            transform: scale(1.05);

            .line {
                opacity: 1 !important;
            }

            .num {
                -webkit-text-stroke: 2px @xtxColor !important;
                opacity: 1 !important;
            }

            .content-left-item-content-title {
                color: @xtxColor !important;

                img {
                    opacity: 1 !important;
                }

            }
        }

        .content-left-item {
            width: 100%;
            height: 25%;
            display: flex;
            padding-top: 1rem;
            position: relative;
            transition: all 0.5s;



            &:hover {
                transform: scale(1.05);

                .line {
                    opacity: 1;
                }

                .num {
                    -webkit-text-stroke: 2px @xtxColor;
                    opacity: 1;
                }

                .content-left-item-content-title {
                    color: @xtxColor !important;

                    img {
                        opacity: 1 !important;
                    }

                }
            }



            .num {
                font-family: PUHUTI;
                margin-top: -0.75rem;
                margin-right: .375rem;
                font-size: 6.25rem;
                -webkit-text-stroke: 2px #3E3A39;
                color: transparent;
                opacity: 0.4;
            }

            .line {
                width: 100%;
                height: .125rem;
                background-color: @xtxColor;
                position: absolute;
                bottom: 0;
                opacity: 0;
                transition: all 0.5s;
            }

            .content-left-item-content {
                flex: 1;
                text-align: left;
                padding-left: .375rem;

                .content-left-item-content-title {
                    font-size: 1.375rem;
                    color: #555555;

                    img {
                        margin-left: 1.25rem;
                        opacity: 0;
                        width: 1.8125rem;
                        height: 1.125rem;
                        transition: all 0.5s;
                    }
                }

                .content-left-item-content-text {
                    margin-top: .375rem;
                    font-size: 1rem;
                    color: #666666;
                }
            }
        }
    }

    .content-right {
        width: 45rem;
        height: 100%;


        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>